import React, { useEffect } from "react";
import { returnMessages } from "../../utils/store/reducers/Message";
import { useDispatch, useSelector } from "react-redux";
import { digiSignerStatus } from "../../utils/apis/userApi";
import { useNavigate } from "react-router-dom";
import { removedContractId } from "../../utils/store/reducers/authSlice";

const ContractSigned = () => {
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = useSelector((state) => state.auth.contractId); // Assuming you get id from state

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id !== null) {
          const response = await digiSignerStatus(id, idToken);
                    if (response?.status <= 202) {
            dispatch(returnMessages("Contract signed successfully.", 200));
          } else {
            dispatch(
              returnMessages(
                "There was an issue with signing the contract. Please try again.",
                400
              )
            );
          }
        }
      } catch (error) {
        dispatch(
          returnMessages(
            "An error occurred while signing the contract. Please try again later.",
            400
          )
        );
      }
      navigate("/");
      dispatch(removedContractId());
    };
    fetchData();
  }, [id, idToken, dispatch, navigate]);

  return <div>Contract Signed</div>;
};

export default ContractSigned;
